/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Sdh_ElementsInputs */



/**
* | output |
* | --- |
* | "Remove SDH Elements" |
*
* @param {Remove_Sdh_ElementsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh_elements = /** @type {((inputs?: Remove_Sdh_ElementsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Sdh_ElementsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les éléments SDH")
	if (locale === "de") return /** @type {LocalizedString} */ ("SDH-Elemente entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi elementi SDH")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить элементы SDH")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar elementos SDH")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("去除SDH元素")
	if (locale === "ja") return /** @type {LocalizedString} */ ("SDH要素を削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एसडीएच तत्वों को हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover elementos SDH")
	return /** @type {LocalizedString} */ ("Remove SDH Elements")
});